import './VtxIcon.scss';
import * as React from 'react';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
import { assertNever } from '../../helpers/neverCheckers';
import { css } from 'emotion';

export const allIconsNames = [
    'alert',
    'align-center',
    'align-left',
    'align-right',
    'apartment',
    'api',
    'appstore',
    'area-chart',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'arrows-alt',
    'audio',
    'audit',
    'backward',
    'bank',
    'bar-chart',
    'barcode',
    'bars',
    'bell',
    'bg-colors',
    'block',
    'bold',
    'book',
    'border',
    'box-plot',
    'branches',
    'bug',
    'build',
    'building',
    'bulb',
    'calculator',
    'calendar',
    'camera',
    'car',
    'caret-down',
    'caret-left',
    'caret-right',
    'caret-up',
    'carry-out',
    'certificate',
    'check',
    'check-calendar',
    'check-circle',
    'check-circle-filled',
    'check-square',
    'checkmark',
    'clock',
    'clock-circle-filled',
    'close',
    'close-circle',
    'close-circle-filled',
    'close-small',
    'close-square',
    'cloud',
    'cloud-download',
    'cloud-server',
    'cloud-sync',
    'cloud-upload',
    'cluster',
    'code',
    'coffee',
    'colum-height',
    'column-width',
    'compass',
    'contacts',
    'container',
    'control',
    'copy',
    'copyright',
    'credit-card',
    'crown',
    'customer-service',
    'dash',
    'dashboard',
    'database',
    'delete',
    'deployment-unit',
    'desktop',
    'diff',
    'disconnect',
    'dislike',
    'dollar',
    'dot-chart',
    'double-left',
    'double-right',
    'down',
    'down-circle',
    'down-square',
    'download',
    'drag',
    'edit',
    'ellipsis',
    'enter',
    'enterprise',
    'environment',
    'euro',
    'exception',
    'exclamation',
    'exclamation-circle',
    'exclamation-circle-filled',
    'export',
    'export-1',
    'eye',
    'eye-invisible',
    'fall',
    'fast-backward',
    'fast-forward',
    'file',
    'file-add',
    'file-done',
    'file-exclamation',
    'file-image',
    'file-minus',
    'file-protect',
    'file-search',
    'file-sync',
    'file-unknown',
    'file-word',
    'file-zip',
    'file-change-filled',
    'filter',
    'flag',
    'folder',
    'folder-add',
    'folder-minus',
    'folder-open',
    'font-colors',
    'font-size',
    'fork',
    'form',
    'forward',
    'frown',
    'fullscreen',
    'fullscreen-exit',
    'fund',
    'funnel-plot',
    'gateway',
    'gift',
    'global',
    'gold',
    'hdd',
    'heart',
    'heat-map',
    'highlight',
    'history',
    'home',
    'hourglass',
    'idcard',
    'import',
    'inbox',
    'info',
    'info-circle',
    'info-circle-filled',
    'insurance',
    'interation',
    'issues-close',
    'italic',
    'key',
    'laptop',
    'layout',
    'left',
    'left-circle',
    'left-square',
    'like',
    'line',
    'line-chart',
    'line-height',
    'link',
    'loading',
    'loading-3-quarters',
    'lock',
    'login',
    'logout',
    'mail',
    'man',
    'map',
    'medicine-box',
    'meh',
    'menu',
    'menu-fold',
    'menu-unfold',
    'message',
    'minus',
    'minus-circle',
    'minus-square',
    'mobile',
    'monitor',
    'more',
    'newtab',
    'notification',
    'number',
    'ordered-list',
    'paper',
    'paper-clip',
    'pause',
    'pause-circle',
    'percentage',
    'phone',
    'pic-center',
    'pic-left',
    'pic-right',
    'picture',
    'pie-chart',
    'play-circle',
    'play-square',
    'plus',
    'plus-circle',
    'plus-circle-filled',
    'plus-square',
    'pound',
    'poweroff',
    'printer',
    'profile',
    'profile-1',
    'project',
    'property-safety',
    'pull-request',
    'pushpin',
    'qrcode',
    'question',
    'question-circle',
    'question-circle-filled',
    'radar-chart',
    'read',
    'receipt',
    'receipts',
    'reconciliation',
    'redo',
    'reload',
    'reporting',
    'rest',
    'retweet',
    'right',
    'right-circle',
    'right-square',
    'rise',
    'robot',
    'rocket',
    'rollback',
    'round-slider',
    'safety',
    'save',
    'scan',
    'schedule',
    'scissor',
    'search',
    'security-scan',
    'select',
    'setting',
    'shake',
    'share-alt',
    'shop',
    'shopping',
    'shopping-cart',
    'shrink',
    'skin',
    'sliders',
    'small-dash',
    'smile',
    'snippets',
    'solution',
    'sort-ascending',
    'sort-descending',
    'sound',
    'star',
    'step-backward',
    'step-forward',
    'stock',
    'stop',
    'strikethrough',
    'swap',
    'swap-left',
    'swap-right',
    'switcher',
    'sync',
    'table',
    'tablet',
    'tag',
    'tags',
    'team',
    'thunderbolt',
    'to-top',
    'tool',
    'tools',
    'trademark',
    'trophy',
    'underline',
    'undo',
    'unlock',
    'unordered-list',
    'up',
    'up-circle',
    'up-square',
    'upload',
    'upload1',
    'usb',
    'user',
    'user-add',
    'user-check',
    'user-delete',
    'usergroup-add',
    'usergroup-delete',
    'vertical-align-bottom',
    'vertical-align-middle',
    'vertical-align-top',
    'vertical-left',
    'vertical-right',
    'video-camera',
    'wallet',
    'warning-filled',
    'warning-outline',
    'wifi',
    'woman',
    'x-calendar',
    'zoom-in',
    'zoom-out',
] as const;

export type IconType = typeof allIconsNames[number];

export const iconColors = ['white', 'blue', 'gray', 'red', 'green', 'orange', undefined] as const;
export type IcoColors = typeof iconColors[number];

function determineColorCssClass(color: IcoColors): string {
    if (color === undefined) {
        return '';
    } else if (color === 'blue') {
        return 'vtx-icon-color-blue';
    } else if (color === 'white') {
        return 'vtx-icon-color-white';
    } else if (color === 'gray') {
        return 'vtx-icon-color-gray';
    } else if (color === 'red') {
        return 'vtx-icon-color-red';
    } else if (color === 'green') {
        return 'vtx-icon-color-green';
    } else if (color === 'orange') {
        return 'vtx-icon-color-orange';
    } else {
        return assertNever(color);
    }
}

export interface VtxIconProps extends React.HTMLAttributes<HTMLSpanElement>, IAutomatable {
    className?: string;
    type: IconType;
    /**
     * Can be a string like '1rem' or a number like 12
     */
    fontSize?: number | string;
    color?: IcoColors;
    flip?: 'horizontally' | 'vertically' | 'both';
}

function determineFlipCSS(flip: VtxIconProps['flip']) {
    if (!flip) {
        return '';
    } else if (flip === 'both') {
        return css`
            &:before {
                display: inline-block;
                transform: scale(-1, -1);
            }
        `;
    } else if (flip === 'horizontally') {
        return css`
            &:before {
                display: inline-block;
                transform: scale(-1, 1);
            }
        `;
    } else if (flip === 'vertically') {
        return css`
            &:before {
                display: inline-block;
                transform: scale(1, -1);
            }
        `;
    } else {
        return assertNever(flip);
    }
}

export const isIconProps = (test: unknown): test is VtxIconProps => {
    if (!Array.isArray(test) && typeof test === 'object') {
        const innocentUntilProvenGuilty = test as Partial<VtxIconProps>;
        let isIcon = true;

        // eslint-disable-next-line array-callback-return
        Object.keys(innocentUntilProvenGuilty).map(key => {
            if (key !== 'classNames' && key !== 'color' && key !== 'type' && key !== 'fontSize') {
                isIcon = false;
            }
        });
        if (innocentUntilProvenGuilty.type && !allIconsNames.includes(innocentUntilProvenGuilty.type)) {
            return false;
        }
        if (innocentUntilProvenGuilty.color && !iconColors.includes(innocentUntilProvenGuilty.color)) {
            return false;
        }
        if (innocentUntilProvenGuilty.className && typeof innocentUntilProvenGuilty.className !== 'string') {
            return false;
        }
        if (innocentUntilProvenGuilty.fontSize) {
            if (
                typeof innocentUntilProvenGuilty.fontSize !== 'string' &&
                typeof innocentUntilProvenGuilty.fontSize !== 'number'
            ) {
                return false;
            }
        }
        return isIcon;
    }
    return false;
};

export const VtxIcon: FunctionComponent<VtxIconProps> = React.memo((props: VtxIconProps) => {
    const automationClass = 'vtx-icon';
    const { className, fontSize, color, type, flip, ...otherProps } = preventDataAutomationOverriding(props);

    const colorClassName = determineColorCssClass(color);
    const flipStyle = determineFlipCSS(flip);

    const classNamesCombined = classNames(
        'vtx-icon',
        automationClass,
        colorClassName,
        {
            [`vtx-icon-${type}`]: type,
        },
        className,
        flipStyle
    );

    return (
        <span
            {...otherProps}
            data-automation-class={automationClass}
            style={{ fontSize: fontSize }}
            className={classNamesCombined}
        />
    );
});
